import { SurveyDataProps } from './props';
import { useSurveyData } from './hook';
import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';

export const SurveyData = ({ survey, loading }: SurveyDataProps) => {
    const { formik } = useSurveyData(survey);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Código"
                    name="code"
                    size="small"
                    value={formik.values.code}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Título"
                    name="title"
                    size="small"
                    value={formik.values.title}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Estado"
                    name="status"
                    size="small"
                    value={
                        formik.values.status === 'active'
                            ? 'Activo'
                            : 'Inactivo'
                    }
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    rows={3}
                    value={formik.values.description}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Guion del Asesor"
                    name="advisor_script"
                    size="small"
                    rows={6}
                    value={formik.values.advisor_script || ''}
                    onChange={undefined}
                />
            </Grid>
        </Grid>
    );
};
